module.exports = __webpack_public_path__ + "img/settings.5e64da2d.svg";